import {useMemo} from 'react';
import {useTheme} from '@mui/material';
import type {ThesaurusAction} from 'types';
import type {SceneExtensionCore} from 'sceneExtensions/types';
import {FieldExtensionEnum} from 'sceneExtensions/types';
import type {MultiThesaurusFieldConfig, MultiThesaurusValue} from '../types';
import {MultiThesaurusEditContainer} from '../MultiThesaurusEditContainer';
import {useMultiThesaurusFieldExtension} from './useMultiThesaurusFieldExtension';

export const useMultiThesaurusEditSceneExtensionCore = () => {
  const fieldExtension = useMultiThesaurusFieldExtension();
  const {palette} = useTheme();

  return useMemo((): SceneExtensionCore<
    FieldExtensionEnum.multiThesaurusEdit,
    MultiThesaurusValue,
    MultiThesaurusValue,
    ThesaurusAction,
    MultiThesaurusFieldConfig
  > => {
    return {
      type: FieldExtensionEnum.multiThesaurusEdit,
      panelConfig: {
        backgroundColour: palette.background.beige.level1,
      },
      renderRightPanel: (onClose: () => Promise<void>) => (
        <MultiThesaurusEditContainer onClose={onClose} />
      ),
      fieldContext: fieldExtension,
    };
  }, [palette, fieldExtension]);
};
